import { Navigate } from "event-definitions"

export function navigate(...params) {
    Navigate.raiseLater(...params)
}
